import { GET_SALESPERSONS_DATA, SALES_REPORT_LOADING } from './types'

const initialState = {
  data: {},
  loading: false,
}

export const salesReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SALESPERSONS_DATA:
      return {
        ...state,
        data: action.payload,
      }
    case SALES_REPORT_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    default:
      return state
  }
}
